import React, { useRef } from 'react';

import Chart from '../Chart/Chart';
import Loader from '../../../../../../../CommunityDashboard/components/CommunityDashboardPage/components/Loader/Loader';

import styles from './ChartMetric.module.css';

export default ({ title, chartData, metricWidth = 100, isSocioDemoChart }) => {
  const chartParentContainer = useRef();
  const tooltipContainerRef = useRef();

  if (!chartData) {
    return (
      <div className={styles.container} style={{ width: `${metricWidth}%` }}>
        <div className={styles.loadingContainer}>
          <Loader fixed={false} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container} style={{ width: `${metricWidth}%` }}>
      <div className={styles.title}>{title}</div>
      <div className={styles.chartContainer} ref={chartParentContainer}>
        <Chart
          title={title}
          parent={chartParentContainer}
          tooltipContainerRef={tooltipContainerRef}
          height={260}
          data={
            chartData.values && chartData.values.length ? chartData.values : []
          }
          unfilteredData={
            chartData.unfilteredValues && chartData.unfilteredValues.length
              ? chartData.unfilteredValues
              : []
          }
          deltaData={
            chartData.deltaValues && chartData.deltaValues.length
              ? chartData.deltaValues
              : []
          }
          isSocioDemoChart={isSocioDemoChart}
        />
        <div ref={tooltipContainerRef} className={styles.tooltipContainer} />
        <div className={styles.legend}>
          <div className={styles.legendItem}>
            <span className={`${styles.bullet} ${styles.green}`} />
            {`> 90% feasible`}
          </div>
          <div className={styles.legendItem}>
            <span className={`${styles.bullet} ${styles.orange}`} />
            {`50% - 90% feasible`}
          </div>
          <div className={styles.legendItem}>
            <span className={`${styles.bullet} ${styles.red}`} />
            {`< 50% feasible`}
          </div>
          <div className={styles.legendItem}>
            <span className={`${styles.bullet} ${styles.lightGrey}`} />
            {`Not selected`}
          </div>
        </div>
      </div>
    </div>
  );
};
